export function htmlToBlocks(html: string) {
  const div = document.createElement('div');
  div.innerHTML = html;

  const blocks: any[] = [];

  function parseChildren(node: ChildNode): any[] {
    const children: any[] = [];
    node.childNodes.forEach(child => {
      if (child.nodeType === 3) { // Text node
        if (child.textContent && child.textContent.trim() !== '') {
          children.push({
            type: 'text',
            text: child.textContent
          });
        }
      } else if (child.nodeType === 1) { // Element node
        const el = child as HTMLElement;
        if ((el.tagName === 'STRONG' || el.tagName === 'B') && el.textContent) {
          children.push({
            type: 'text',
            text: el.textContent || '',
            bold: true
          });
        } else if ((el.tagName === 'EM' || el.tagName === 'I') && el.textContent) {
          children.push({
            type: 'text',
            text: el.textContent || '',
            italic: true
          });
        } else if ((el.tagName === 'U') && el.textContent) {
          children.push({
            type: 'text',
            text: el.textContent || '',
            underline: true
          });
        } else if ((el.tagName === 'S' || el.tagName === 'DEL') && el.textContent) {
          children.push({
            type: 'text',
            text: el.textContent || '',
            strikethrough: true
          });
        } else if (el.tagName === 'CODE' && el.textContent) {
          children.push({
            type: 'text',
            text: el.textContent || '',
            code: true
          });
        } else if (el.tagName === 'A' && el.textContent) {
          children.push({
            type: 'link',
            url: el.getAttribute('href') || '',
            children: [{ type: 'text', text: el.textContent || '' }]
          });
        } else {
          // Recursivo para otros elementos anidados
          children.push(...parseChildren(child));
        }
      }
    });
    return children;
  }

  div.childNodes.forEach(node => {
    if (node.nodeType !== 1) return;
    const el = node as HTMLElement;

    // Headings
    if (/^H[1-6]$/.test(el.tagName) && el.textContent) {
      blocks.push({
        type: 'heading',
        level: Number(el.tagName[1]),
        children: parseChildren(node)
      });
    }
    // Paragraph
    else if (el.tagName === 'P' && el.textContent) {
      blocks.push({
        type: 'paragraph',
        children: parseChildren(node)
      });
    }
    // Unordered List
    else if (el.tagName === 'UL' && el.textContent) {
      blocks.push({
        type: 'list',
        format: 'unordered',
        children: Array.from(el.children).filter(li => li.tagName === 'LI').map(li => ({
          type: 'list-item',
          children: parseChildren(li)
        }))
      });
    }
    // Ordered List
    else if (el.tagName === 'OL' && el.textContent) {
      blocks.push({
        type: 'list',
        format: 'ordered',
        children: Array.from(el.children).filter(li => li.tagName === 'LI').map(li => ({
          type: 'list-item',
          children: parseChildren(li)
        }))
      });
    }
  });

  return blocks;
}

export function blocksToHtml(blocks: any[]): string {
  if (!Array.isArray(blocks)) return '';

  function renderText(child: any) {
    let text = child.text || '';
    if (child.bold) text = `<strong>${text}</strong>`;
    if (child.italic) text = `<em>${text}</em>`;
    if (child.underline) text = `<u>${text}</u>`;
    if (child.strikethrough) text = `<s>${text}</s>`;
    if (child.code) text = `<code>${text}</code>`;
    return text;
  }

  function renderChildren(children: any[]): string {
    return children
      .map(child => {
        if (child.type === 'text') {
          return renderText(child);
        }
        if (child.type === 'link') {
          return `<a href="${child.url}" target="_blank">${renderChildren(child.children || [])}</a>`;
        }
        return '';
      })
      .join('');
  }

  return blocks
    .map(block => {
      if (block.type === 'paragraph') {
        return `<p>${renderChildren(block.children || [])}</p>`;
      }
      if (block.type === 'heading') {
        const level = block.level || 1;
        return `<h${level}>${renderChildren(block.children || [])}</h${level}>`;
      }
      if (block.type === 'list') {
        const tag = block.format === 'ordered' ? 'ol' : 'ul';
        const items = (block.children || []).map((item: any) => {
          const content = renderChildren(item.children || []);
          return '<li>' + content + '</li>';
        }).join('');
        return '<' + tag + '>' + items + '</' + tag + '>';
      }
      return '';
    })
    .join('');
}